/**
 * Format law firm search API rows for async look-ahead / match lists.
 * Label: "CODE - Name" when code exists; otherwise name only.
 */
export function formatLawFirmSearchLabel(element) {
    if (!element) {
        return ''
    }
    const name = element.name ?? ''
    const code = element.code
    if (code) {
        return `${code} - ${name}`
    }
    return name
}

/**
 * Build a react-select / custom-select option from a law firm search result.
 * When path is not law-firms, returns a plain name option (caller may override value).
 */
export function formatAsyncSearchOption(element, path) {
    const isLawFirm = path === 'law-firms'
    const item = {
        label: isLawFirm ? formatLawFirmSearchLabel(element) : element.name,
        value: element.id,
        code: element.code,
        tag: path,
        id: element.id,
        name: element.name,
        verified: element.verified,
    }

    if (path === 'law-firm-locations' || path === 'law-firm-attorneys') {
        item.value = element.law_firm_id
    }
    if (path === 'insurance-carrier-locations') {
        item.value = element.insurance_carrier_id
    }

    return item
}

export function isLawFirmUnverified(verified) {
    return verified == 0 || verified === false
}

export function isLawFirmVerified(verified) {
    return verified == 1 || verified === true
}
